import { useMemo } from 'react';

import tagCollectionBlogPostsQuery from '@glass/shared/modules/content/queries/tagCollectionBlogPosts.graphql';
import useContentfulQuery from '@glass/shared/modules/content/useContentfulQuery';

const useRelatedResources = ({ limit, relatedTags, skip }) => {
  const options = useMemo(() => {
    const OR = relatedTags?.filter((a) => a?.slug || a).map((tag) => ({ slug: tag }));

    return {
      skip: !OR?.length || skip,
      variables: {
        limit: 1,
        tagLimit: 5,
        blogPostLimit: limit,
        where: { OR },
      },
    };
  }, [relatedTags, skip, limit]);

  const { data, loading } = useContentfulQuery(tagCollectionBlogPostsQuery, options);

  return useMemo(() => {
    const { items } = data?.tagCollection?.items?.[0]?.linkedFrom?.blogPostCollection || {};
    return {
      data,
      loading,
      posts: items?.length
        ? items
            .slice()
            .sort?.(
              (a, b) =>
                new Date(b.updatedAt || b.publishedAt) - new Date(a.updatedAt || a.publishedAt),
            )
            .slice(0, limit)
        : null,
    };
  }, [data, limit, loading]);
};

export default useRelatedResources;
